import React, { Component } from "react";
import _ from "lodash";
import LazyLoad from "react-lazyload";
import I18n from "../../../../i18n/I18n";
import Helper from "../../../../helper/Helper";
import CONFIG from "../../../../config";
import styles from "./OrderDetailsRow.scss";

class OrderDetailsRow extends Component {
  state: {
    acceptedQty: string
  };
  selectQtyChange: Function;
  constructor(props) {
    super(props);
    this.state = {
      acceptedQty: props.order.accepted_quantity
    };
  }
  selectQtyChange(e: Object) {
    this.setState({
      acceptedQty: e.value
    });
    const changedOffer = {
      id_offer: this.props.order.idOffer,
      quantity: e.value
    };
    this.props.onQtyChange(changedOffer);
  }
  render() {
    const order = this.props.order || "";

    const qtyOptions = [];
    for (let i = order.accepted_quantity; i >= 0; i--) {
      qtyOptions.push({ value: i, label: `${i}` });
    }
    const placeholder = (
      <img
        src={`${CONFIG.BASE_IMG_URL}nr/misc/product-image-default.jpg`}
        alt="default"
      />
    );

    return (
      <tr className={`${styles.row}`}>
        <td onClick={() => this.props.openDetail(order.idOffer)}>
          <div className={styles.nameWrapper}>
            <div className={styles.itemImg}>
              <LazyLoad
                height="100%"
                once
                placeholder={placeholder}
                offset={100}
              >
                <img
                  src={Helper.getTransformationUrl(order.imagekey)}
                  alt="product"
                />
              </LazyLoad>
            </div>
            <div>
              {order.itemName}
              <div className={styles.attributes}>
                <span>
                  {order.variant ? (
                    <span className={styles.eachAttr}>
                      {I18n.getHtml(
                        "order-details.variant",
                        { variant: order.variant },
                        "Variant: <a>{variant}</a>"
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                </span>
                <span>
                  {order.model ? (
                    <span className={styles.eachAttr}>
                      {I18n.getHtml("order-details.model", {
                        model: order.model
                      })}
                    </span>
                  ) : (
                    ""
                  )}
                </span>
                {order.attributes &&
                !_.isEmpty(JSON.parse(order.attributes)) ? (
                  <span className={styles.eachAttr}>
                    {JSON.parse(order.attributes).colour_family ? (
                      <span>
                        {I18n.getHtml(
                          "order-details.color",
                          { color: JSON.parse(order.attributes).colour_family },
                          "Color: <a>{color}</a>"
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </td>
        <td onClick={() => this.props.openDetail(order.idOffer)}>
          {order.itemNr}
        </td>
        <td onClick={() => this.props.openDetail(order.idOffer)}>
          {order.sku}
        </td>
        <td onClick={() => this.props.openDetail(order.idOffer)}>
          {order.partnerSku}
        </td>
        <td
          onClick={() => this.props.openDetail(order.idOffer)}
          className={styles.priceTd}
        >
          {I18n.formatCurrency(
            Helper.formatPrice(order.price, this.props.currencyCode)
          )}
        </td>
        <td>
          <div>{this.state.acceptedQty}</div>
        </td>
        <td onClick={() => this.props.openDetail(order.idOffer)}>
          {order.quantity}
        </td>
        <td>
          {I18n.formatCurrency(
            Helper.formatPrice(order.itemTotal, this.props.currencyCode)
          )}
        </td>
      </tr>
    );
  }
}

export default OrderDetailsRow;



// WEBPACK FOOTER //
// ./src/components/orders/orderDetails/orderDetailsRow/OrderDetailsRow.js